module.exports = __webpack_public_path__ + "img/customer_act.60b7a1db.png";